module.exports = __webpack_public_path__ + "media/home/newsletter-74c5eebd.png";